import React from "react";
import Template from "../components/Template";
import BreadCrumbHero from "../components/BreadCrumbHero";
import CTA from "../components/CTA";
import { Link } from "react-router-dom";
import CustomBanner from "../components/CustomBanner";

function Performance() {
  return (
    <Template>
      <CustomBanner
        pageTitle=" Performance Leadership"
        pageSubTitle="Executive-grade performance development for individuals ready to elevate focus, execution, and decision quality."
        linkText={"Apply for Performance Leadership"}
        linkUrl={"/apply-performance-leadership"}
        bgImage={"assets/images/daily/b2.jpeg"}
        styles={{ backgroundSize: "450px" }}
      />
      {/* <BreadCrumbHero
        pageTitle=" Performance Leadership"
        pageSubTitle="Executive-grade performance development for individuals ready to elevate focus, execution, and decision quality."
        linkText={"Apply for Performance Leadership"}
        linkUrl={"/apply-performance-leadership"}
      /> */}

      {/* Ihbox Start */}
      <section className="ihbox-section-one">
        <div className="container">
          <div
            className="pbmit-heading-subheading animation-style1"
            style={{ textAlign: "center", marginBottom: "50px" }}
          >
            <h4 className="pbmit-subtitle">
              <span></span>Coach
            </h4>
            <h2 className="pbmit-title">About the Coach</h2>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        My Coaching Approach
                      </h2>
                      <p
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        My coaching approach is shaped by real world leadership
                        experience, professional training, and living the same
                        pressures my clients face every day. Before moving into
                        coaching, I worked across multiple roles in the industry
                        and currently hold a managerial position in a
                        high responsibility environment.
                      </p>

                      <p
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Through managing people, deadlines, and constant
                        expectations, I learned a critical truth about career
                        performance: most professionals don’t struggle because
                        they lack motivation or ambition they struggle because
                        their energy is mismanaged, their routines don’t support
                        their workload, and decision fatigue slowly erodes focus
                        and confidence.
                      </p>

                      <h2 className="pbmit-element-title">
                        Performance, Energy & Clarity
                      </h2>
                      <p
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        High pressure work environments revealed how deeply
                        physical capacity and mental clarity are connected. When
                        the body is depleted, focus drops. When focus drops,
                        decision making suffers. Over time, even high performers
                        experience inconsistency and burnout not due to lack of
                        capability, but because the systems supporting their
                        work and life are unsustainable.
                      </p>

                      <h2 className="pbmit-element-title">
                        Professionally Trained, Real World Grounded
                      </h2>
                      <p
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Alongside my industry experience, I am a certified coach
                        trained under the International Coaching Federation
                        (ICF). This ensures my coaching follows global
                        professional standards, ethical practices, and a
                        structured, client centered approach grounded in real
                        work life demands, not theory.
                      </p>

                      <h2 className="pbmit-element-title">
                        Sustainable High Performance
                      </h2>
                      <p
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        I don’t believe in pushing harder, hustling longer, or
                        sacrificing personal life for success. I believe in
                        building sustainable career performance from the inside
                        out starting with physical capacity, then creating
                        simple systems that protect energy, sharpen focus, and
                        support clear decision making under real world pressure.
                      </p>

                      <p
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        This coaching is designed to help you perform better in
                        your career and live better outside of work with
                        clarity, structure, and performance systems that fit
                        real work life, not ideal schedules.
                      </p>

                      <h2 className="pbmit-element-title">
                        Build a High Performance Career Without Burning Out
                      </h2>
                      <p
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        A structured coaching program for professionals and
                        leaders who want clarity, balance, and long term
                        success.
                      </p>

                      <p
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify", fontWeight: "500" }}
                      >
                        Join a Free Clarity Session get clear on where your
                        energy, focus, and routines are holding you back, and
                        identify what to fix first.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 text-center mt-5">
              <Link to="/apply-performance-leadership" className="pbmit-btn pbmit-btn-white">
                Apply Now
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Ihbox End */}

      {/* Ihbox Start */}
      <section className="ihbox-section-one">
        <div className="container">
          <div
            className="pbmit-heading-subheading animation-style1"
            style={{ textAlign: "center", marginBottom: "50px" }}
          >
            <h4 className="pbmit-subtitle">
              <span></span>Who This Is For
            </h4>
            <h2 className="pbmit-title">Built for High Performance</h2>
          </div>

          <div className="row">
            <div className="col-md-6 py-4">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        Founders & Leaders
                      </h2>
                      <div
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Designed for decision makers who need physical energy,
                        mental clarity, and resilience to lead effectively while
                        managing high responsibility and constant demands.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 py-4">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        High Performing Professionals
                      </h2>
                      <div
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Ideal for driven professionals balancing demanding work,
                        limited time, and the need to maintain consistent
                        physical and mental performance.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 py-4">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        Individuals Under Pressure
                      </h2>
                      <div
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Built for those experiencing sustained mental or
                        physical pressure who want structure, recovery, and
                        balance without adding more stress to their routine.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 py-4">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        Long Term Performers
                      </h2>
                      <div
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Perfect for individuals focused on sustainable
                        performance, avoiding burnout, and building habits that
                        support long term health and consistent results.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Ihbox End */}

      {/* Ihbox Start */}
      <section className="ihbox-section-one">
        <div className="container">
          <div className="row">
            <div className="col-xl-4 col-md-6">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        Fitness Consistency or Performance Assessment
                      </h2>
                      <div className="pbmit-heading-desc">
                        We begin by evaluating your current fitness habits,
                        energy levels, recovery, and overall performance to
                        understand where you are starting from.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        Application Review
                      </h2>
                      <div className="pbmit-heading-desc">
                        Your application is carefully reviewed to ensure
                        alignment with our performance focused approach,
                        long term sustainability, and commitment to consistency.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        Invitation to Performance Leadership
                      </h2>
                      <div className="pbmit-heading-desc">
                        Selected individuals receive an invitation to
                        Performance Leadership, unlocking structured routines,
                        expert guidance, accountability, and long term
                        performance support.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Ihbox End */}

      {/* <CTA
        subtitle="Performance Leadership"
        title="Earn the upgrade. Lead with clarity."
        link="/apply-performance-leadership"
        ctaText="Apply for Performance Leadership"
        accentColor="#05AAE3"
      /> */}
    </Template>
  );
}

export default Performance;
